import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Content from '../../../../components/Section/Content';
import Box from '../../../../components/Section/Box';
import { ListProviders } from './styles';
import CollapsibleProvider from './CollapsibleProvider';
import { api } from '../../../../services/api';
import { useAuth } from '../../../../hooks/useAuth';

/* eslint-disable camelcase */
export type Provider = {
  ueid: string;
  name: string;
  image: string;
  association_date: string;
  slug: string;
  is_owner: boolean;
  is_migrated: boolean;
  international: boolean;
};

export type BoxProvidersProps = {
  providersInfo: Array<Provider>;
};

const BoxProviders = ({ providersInfo = [] }: BoxProvidersProps) => {
  const [providers, setProviders] = useState<Array<Provider>>(providersInfo);
  const { authenticateOnAPI } = useAuth();

  const title = 'Operadoras Associadas';
  const describeTitle = 'Gerencie as operadoras associadas a sua Conta Globo';

  const removeProvider = async (provider: Provider) => {
    const token = await authenticateOnAPI();
    return new Promise<void>((resolve, reject) => {
      api
        .delete('/providers', {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          data: {
            provider_account_id: provider.ueid,
            international: provider.international,
            is_migrated: provider.is_migrated,
          },
        })
        .then(response => {
          if (response.status === 204) {
            toast.success(`${provider.name} foi desassociado com sucesso`);
            setProviders(
              providers.filter(
                (providerToRemove: Provider) =>
                  providerToRemove.ueid !== provider.ueid,
              ),
            );
          }
          return resolve();
        })
        .catch(() => {
          toast.error(`Erro ao desassociar ${provider.name}`);
          return reject();
        });
    });
  };

  return (
    <>
      {providers.length > 0 && (
        <Box title={title} describeTitle={describeTitle}>
          <Content>
            <ListProviders>
              {providers.map(provider => (
                <React.Fragment key={provider.ueid}>
                  <CollapsibleProvider
                    provider={provider}
                    removeProvider={removeProvider}
                  />
                  <hr aria-hidden />
                </React.Fragment>
              ))}
            </ListProviders>
          </Content>
        </Box>
      )}
    </>
  );
};
export default BoxProviders;
